import React, { useEffect } from 'react';
import Breadcrumbs from '../../common/breadcrumbs';
import AOS from 'aos';
import 'aos/dist/aos.css';

const PrivacyPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const data = `<div id="page0">

            <p>
               <b>
                  <span>
                     1. Rental Term, Booking Details &amp; Extension Clause
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  This Agreement covers the rental period as set out above.
               </span>
               <span>
               </span>
            </p>
            <p>
               <i>
                  <span>
                     Extension Clause:
                  </span>
               </i>
               <span>
               </span>
            </p>
            <p>
               <span>
                  If the Renter does not return the Rental Vehicle by the scheduled end date/time, the rental period
                  shall automatically extend on a day-to-day basis at the same daily rental rate. All other terms and
                  conditions of this Agreement remain in full force during any extension. No additional signature is
                  required for such automatic extensions unless there is a material change to the terms.

                  Extensions beyond a predetermined continuous period may require written confirmation by both parties.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     2. Payment Model Options
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  The Renter must select one of the following payment models:
               </span>
               <span>
               </span>
            </p>



            <div class="option1">
               <div class={payment_model}>
                  <p>
                     <span>•</span>
                     <b>Option 1 – Direct Payment Model:</b>
                  </p>
                  <p>
                     The Renter shall make all payments directly to the Owner. Daily rental fees, additional mileage
                     charges, and
                     other applicable fees will be paid by the Renter using the designated payment method. Failure to
                     make timely
                     payments may result in remote disablement of the vehicle or termination of this Agreement.
                  </p>
               </div>
            </div>

            <div class="option2">
               <div class={payment_model}>
                  <p>
                     <span>•</span>
                     <b>Option 2 – Fleet Program Payment Model:</b>
                  </p>
                  <p>
                     The Renter participates in a Fleet Program. Under this model, all fares earned through rideshare or
                     fleet
                     platforms using the Rental Vehicle will be deposited into the Owner’s designated Fleet Account. At
                     the end of each
                     payment period, the Owner will deduct the rental fee, any additional charges (including tolls,
                     fees, or fuel
                     discrepancies), and other agreed-upon expenses from the earnings before transferring the remaining
                     balance to the
                     Renter. Should the earnings be insufficient to cover these charges, the Renter must pay the
                     difference immediately.
                  </p>
               </div>
            </div>

         </div>
         <div id="page0">

            <p>
               <b>
                  <span>
                     3. Fuel Policy
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Fuel Level at Pickup:
                  </span>
               </b>
               <span>
                  The fuel tank should be full at the time of pickup. If the fuel tank is not full, the Renter must
                  immediately notify Fairpy.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Fuel Level at Drop-off:
                  </span>
               </b>
               <span>
                  Upon return, the fuel level will be jointly recorded by both parties.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Fuel Discrepancy:
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
               <span>
                  If the fuel level at drop-off is lower than at pickup, the Renter agrees to pay for the difference
                  based on the current fuel price, plus a $15 convenience fee for refueling.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
               <i>
                  <span>
                     Example:
                  </span>
               </i>
               <span>
                  If the vehicle is picked up with 95% fuel and returned with 75% fuel, the Renter shall be responsible
                  for refilling the missing 20% of the tank plus the $15 fee.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     4. Accident and Non-Drivable Vehicle Provision
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  In the event of an accident that renders the Rental Vehicle non-drivable, responsibility for damage
                  shall be determined based
                  on the extent of the damage and the applicable insurance coverage. Fairpy reserves the right to
                  provide a backup vehicle at its discretion. Furthermore, if Fairpy deems it necessary to retain

                  any portion of the rent paid in advance to offset the deductible or additional costs arising from the
                  accident, no refund shall be

                  provided for that portion.
               </span>

            </p>



         </div>
         <div id="page0">
            <p>
               <b>
                  <span>
                     5. Scope of Use
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Rental Vehicle may be used for ridesharing, carshare, or
                  other fleet programs. If used for these purposes, the Renter must
                  provide a 3-month driving history from the respective platform
                  prior to approval.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Renter must notify the Owner if the vehicle is to be taken
                  out of state.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • Only the Renter and approved additional drivers (all with valid
                  licenses) may operate the vehicle.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Rental Vehicle shall only be used within the designated
                  geographical boundaries.
               </span>
               <span>
               </span>
            </p>
            <p>
               <i>
                  <span>
                     Prohibited Uses:
                  </span>
               </i>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Racing, towing, off-roading, or any unauthorized commercial
                  use.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Transporting hazardous materials or illegal substances.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Driving under the influence of alcohol, drugs, or other impairing
                  substances.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Permitting unapproved drivers to operate the vehicle.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Exceeding the approved geographical boundaries without prior
                  authorization.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Subleasing the vehicle.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  – Tampering with or disabling GPS tracking systems, AirTags, or
                  other vehicle monitoring devices.
               </span>
               <span>
               </span>
            </p>
            <p>
               <i>
                  <span>
                     Additional Provisions:
                  </span>
               </i>
               <span>
               </span>
            </p>
            <p>
               <span>
                  –
               </span>
               <b>
                  <span>
                     Acknowledgment of Existing Damage:
                  </span>
               </b>
               <span>
                  All pre-existing damage shall be documented and agreed upon by both parties before the rental period
                  commences.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  –
               </span>
               <b>
                  <span>
                     False Information:
                  </span>
               </b>
               <span>
                  Any false or misleading information provided by the Renter may void this Agreement.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  –
               </span>
               <b>
                  <span>
                     Restricted Areas for Driving:
                  </span>
               </b>
               <span>
                  The vehicle must not be driven outside the specified rental boundaries without written permission.
               </span>

            </p>

         </div>
         <div id="page0">
            <p>
               <span>
                  –
               </span>
               <b>
                  <span>
                     Unauthorized Modifications:
                  </span>
               </b>
               <span>
                  The vehicle must not be altered or modified; violations may result in immediate termination of this
               </span>
            </p>
            <p>
               <span>
                  Agreement.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     6. Vehicle Tracking and Disabling
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  The Rental Vehicle is equipped with GPS tracking, AirTags, and
                  geofencing technology. The Owner reserves the right to remotely
                  disable the vehicle if:
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • Payment is not received or any terms of this Agreement are
                  violated.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • Unauthorized long-distance travel or suspicious activity occurs.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Renter fails to respond to communications for more than 48
                  hours.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  Any tampering with the tracking or geofencing systems shall
                  result in immediate termination of this Agreement and may lead to
                  legal action.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     7. Recovery Compensation Policy
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  If the Renter fails to return the vehicle to its designated location,
                  the following fees shall apply:
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • For distances between 0.5 and 24.99 miles: $200
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • For distances between 25 and 49.99 miles: $350
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • For distances between 50 and 99.99 miles: $500
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • For distances of 100 miles and over: $1,000 or more
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  These fees are non-negotiable and will be deducted from any security deposit or billed separately.
               </span>

            </p>
            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     8. Additional Responsibilities &amp; Liabilities
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Security Deposit &amp; Damage Coverage:
                  </span>
               </b>
               <span>
                  The Renter shall pay
                  for any damages exceeding the security deposit within 7 days.
               </span>
            </p>

         </div>
         <div id="page0">
            <p>
               <span>
                  The Owner reserves the right to send unpaid balances to
                  collections after the specified timeframe.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Smoking &amp; Pet Policy:
                  </span>
               </b>
               <span>
                  A cleaning fee of $150 will be charged if
                  the vehicle is returned with evidence of smoke, pet hair, odors, or
               </span>
               excessive dirt.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Traffic Violations:
                  </span>
               </b>
               <span>
                  The Renter is responsible for any tolls,
                  tickets, or traffic violations incurred during the rental period.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Lost or Unreturned Keys:
                  </span>
               </b>
               <span>
                  The replacement cost is $500 per key.
               </span>
            </p>

            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Excessive Wear and Tear:
                  </span>
               </b>
               <span>
                  Any damage beyond normal wear shall be fully charged to the Renter.
               </span>
            </p>
            <p>

            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Odometer Tampering &amp; Unauthorized Repairs:
                  </span>
               </b>
               <span>
                  Any tampering with the odometer or unauthorized repairs will render the Renter liable for all
                  associated costs.
               </span>
            </p>

            <p>

            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Vehicle Condition Monitoring:
                  </span>
               </b>
               <span>
                  The Renter must submit clear weekly photos of the vehicle’s interior, exterior, and dashboard via
               </span>
            </p>

            <p>
               <span>
                  SMS or WhatsApp. If the vehicle is deemed excessively dirty or neglected, the Owner may recover the
                  vehicle immediately without prior notice.
               </span>
            </p>


            <p>
               <span>
                  •
               </span>
               <b>
                  <span>
                     Late fee:
                  </span>
               </b>
               <span>
                  A late fee of $5 per hour will be charged for every additional hour from the time of reservation drop
                  off time
               </span>
            </p>


         </div>
         <div id="page0">
            <p>
               <b>
                  <span>
                     9. Governing Law and Dispute Resolution
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  This Agreement shall be governed by the laws of the applicable jurisdiction. Any disputes arising
                  herein shall first be resolved through mediation or arbitration prior to litigation. This document
                  represents the entire Agreement between the parties, and all modifications must be made in writing and
                  signed by both parties.
               </span>
            </p>


            <p>
               <span>
                  Should any provision be found unenforceable, the remainder of the Agreement shall continue in full
                  force. All notices or communications must be in writing and sent to the addresses
                  provided by the parties.
               </span>
            </p>

            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     10. Termination of Agreement
                  </span>
               </b>
               <span>
               </span>
            </p>
            <p>
               <span>
                  This Agreement may be terminated immediately if:
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Renter breaches any term of this Agreement.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • Payments are not made on time.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Rental Vehicle is used for unauthorized purposes.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  • The Renter fails to return the vehicle after notice from the Owner.
               </span>
            </p>

            <p>
               <span>
                  • Fraudulent activities, unauthorized subleasing, or reckless driving are identified.
               </span>
            </p>

            <p>
               <span>
                  Upon termination, the Renter must return the vehicle within 24 hours; otherwise, it may be reported as
                  stolen.
               </span>
            </p>

            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                     11. Indemnification, Liability &amp; Security
                  </span>
               </b>
               <b>
                  <span>
                  </span>
               </b>
            </p>
            <p>
               <b>
                  <span>
                     Indemnification &amp; Liability Waiver
                  </span>
               </b>
               <b>
                  <span>
                  </span>
               </b>
            </p>
            <p>
               <span>
                  The Renter agrees to indemnify, defend, and hold harmless the
                  Owner, its agents, employees, successors, and assigns, from and
                  against any and all claims, demands, liabilities, damages, losses,
                  costs, expenses, fines, penalties, and legal fees, including but not limited to, those arising from:
               </span>
            </p>

         </div>
         <div id="page0">

            <p>
               <span>
                  a) Any accident, injury, death, or property damage caused during
                  the Renter’s operation of the Vehicle for rideshare or delivery
                  services (e.g., Uber, Lyft, DoorDash, Instacart, etc.). b) Any
                  insurance claim denial due to the Renter’s commercial use of the
                  Vehicle, including instances where the Owner’s personal
                  insurance does not cover business use. c) Any third-party claims
                  resulting from the Renter’s negligence, reckless driving, failure to
                  follow traffic laws, or use of the Vehicle in a manner inconsistent
                  with the terms of this Agreement. d) Any mechanical breakdown,
                  excessive wear and tear, or additional maintenance costs caused
                  by commercial use, including but not limited to tire damage, oil
                  changes, brake wear, or excessive mileage-related issues. e) Any
                  fines, tolls, parking tickets, or legal violations incurred during the
                  rental period. f) Any claims from Uber, Lyft, or other rideshare/delivery companies due to a violation
                  of their policies, including vehicle disqualification.
               </span>
            </p>

            <p>
               <b>
                  <span>
                     No Owner Liability for Rideshare Activity
                  </span>
               </b>
               <b>
                  <span>
                  </span>
               </b>
            </p>




            <p>
               <span>
                  The Owner shall not be held responsible for any damages,
                  lawsuits, insurance disputes, or claims resulting from the Renter’s
                  operation of the Vehicle for rideshare or delivery services. The
                  Renter acknowledges that the Owner’s personal auto insurance
                  may not provide coverage while the Vehicle is used for
                  commercial purposes.
               </span>
            </p>



            <p>
               <span>
                  Renter’s Insurance as Primary Coverage
                  shall be the primary coverage for any damages, liabilities, or
                  claims related to the Vehicle’s use. If the Renter fails to obtain
                  proper insurance, they assume full financial responsibility for all losses.
               </span>
            </p>


            <p>
               <b>
                  <span>
                     Assumption of Risk
                  </span>
               </b>

            </p>

         </div>
         <div id="page0">
            <p>
               <span>
                  The Renter acknowledges and assumes all risks associated with the use of the Vehicle for rideshare or
                  delivery services, including but not limited to increased accident risks, vandalism, passenger-
                  related disputes, and liability exposure.
               </span>
            </p>

            <p>
               <b>
                  <span>
                     Security Deposit for Excess Wear &amp; Tear
                  </span>
               </b>
               <b>
                  <span>
                  </span>
               </b>
            </p>


            <p>
               <span>
                  To mitigate risks related to commercial use, the Renter agrees to provide a refundable security
                  deposit upfront. The security deposit is refundable, provided that the Vehicle is returned in clean
                  condition, with no damage, and with all tolls and fines paid. Any damages, excessive wear and tear, or
                  outstanding toll charges will be deducted from the security deposit before a refund is issued.
               </span>
            </p>


            <p>
               <b>
                  <span>
                     Termination for Policy Violations
                  </span>
               </b>
               <b>
                  <span>
                  </span>
               </b>
            </p>
            <p>
               <span>
                  The Owner reserves the right to terminate this agreement immediately if the Renter:
               </span>
            </p>

            <p>
               <span>
                  •
               </span>
               <span>
               </span>
               <span>
                  Fails to maintain proper rideshare insurance.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
                  •
               </span>
               <span>
               </span>
               <span>
                  Operates the Vehicle in a way that leads to excessive wear, damage, or devaluation.
               </span>
            </p>

            <p>
               <span>
                  •
               </span>
               <span>
               </span>
               <span>
                  Engages in reckless or illegal driving behavior.
               </span>
               <span>
               </span>
            </p>
            <p>
               <span>
               </span>
            </p>
            <p>
               <b>
                  <span>
                  </span>
               </b>
            </p>
            <p>
               <b>
                  <span>
                  </span>
               </b>
            </p>

         </div>
            </div>
               </div>
                  </div>
                 
        
`;

  return (
    <div className="main-wrapper">
      <Breadcrumbs title="Privacy Policy" subtitle="Pages" />
      <div className="privacy-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-5">
              <div
                dangerouslySetInnerHTML={{
                  __html: data,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
